module.exports = __webpack_public_path__ + "static/media/export.1f43f88c.svg";